import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { getTutorCompletedAssStudentDetail } from '../../../../../Redux/action/TutorAction';
import Beatloader from '../../../../../Common/BeatLoader';

const host = process.env.REACT_APP_API_SERVER
const TutorSubjectiveTest = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const assessment_id = location?.state?.assessment_id;
    const student_id = location?.state?.student_id;

    useEffect(() => {
        if (assessment_id && student_id) {
            console.log('Dispatching action with:', { assessment_id, student_id });
            dispatch(getTutorCompletedAssStudentDetail(assessment_id, student_id));
        } else {
            console.log('Redirecting to the previous page');
            navigate(-1);
        }
    }, [assessment_id, student_id, dispatch, navigate]);




    const {
        loadingTutorCompletedAssStudentDetailApi,
        TutorCompletedAssStudentDetailApiData,
        TutorCompletedAssStudentDetailApiError

    } = useSelector(state => state?.TutorReducer);


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Subjective Test
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorCompletedAssStudentDetailApi ?
                                    <Beatloader />
                                    :
                                    <div className="my-schedule-detail-sec">
                                        <div className="row">
                                            <div className="col-lg-2 col-md-4">
                                                <img
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                    src={`${host}/${TutorCompletedAssStudentDetailApiData?.student?.profile_img}`} className="img-fluid w-auto" />
                                            </div>
                                            <div className="col-lg-7 col-md-8">
                                                <h4 className="mb-0 mt-4 fw-bold">Student Name : {TutorCompletedAssStudentDetailApiData?.student?.name}</h4>
                                                <p className="mb-0 fw-bold">Assessment Name : {TutorCompletedAssStudentDetailApiData?.assessment?.assesment_name}</p>
                                                <p className="mb-0 fw-bold">Course Name : {TutorCompletedAssStudentDetailApiData?.assessment?.course?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0 mt-2 fw-bold text-end">
                                                    <i className="bi bi-hourglass-split me-1" />{TutorCompletedAssStudentDetailApiData?.assessment?.duration} Min
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row mt-4 mb-3">
                                            <div className="col-lg-3 col-md-4">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <p className="mb-0 fw-bold">{TutorCompletedAssStudentDetailApiData?.assessment?.course?.category?.name}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4">
                                                <p className="mb-0">Subject</p>
                                                <p className="mb-0 fw-bold">{TutorCompletedAssStudentDetailApiData?.assessment?.course?.subcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4">
                                                <p className="mb-0">Module</p>
                                                <p className="mb-0 fw-bold">{TutorCompletedAssStudentDetailApiData?.assessment?.course?.childcategory?.name}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">No. of Questions</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.no_of_question}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">Total Marks</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.total_marks}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">Duration</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.duration} Min</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">Day</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.assesment_day}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">Assign Date</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.assesment_date}</p>
                                            </div>
                                            <div className="col-lg-3 col-md-4 mb-3">
                                                <p className="mb-0">Submit Date</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorCompletedAssStudentDetailApiData?.assessment?.assesment_submit_date}</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="col-lg-3 mb-3">
                                                <Link to="/tutor/tutor-subjective-test-update" state={{ assessment_id: TutorCompletedAssStudentDetailApiData?.assessment?.id, student_id: TutorCompletedAssStudentDetailApiData?.student?.id }}>
                                                    <button className="btn btn-primary w-100">Update Result</button>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <button
                                                    className="btn btn-outline-primary w-100"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#gradeModal"
                                                >
                                                    View Result
                                                </button>
                                            </div>
                                        </div>
                                    </div>}
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Grade Modal */}
                <div
                    className="modal fade logout-modal"
                    id="gradeModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content h-75">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div
                                className="modal-body my-4"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    className="border rounded-circle bg-primary text-white mb-3"
                                    style={{
                                        height: "8rem",
                                        width: "8rem",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <h4>{Math.ceil(TutorCompletedAssStudentDetailApiData?.student?.percentage)}%</h4>
                                    <h5>Grade {TutorCompletedAssStudentDetailApiData?.student?.grade}</h5>
                                </div>
                                <h6 className="mb-0">{TutorCompletedAssStudentDetailApiData?.student?.remark}</h6>
                                <h5 className="mb-3">{TutorCompletedAssStudentDetailApiData?.student?.name}</h5>
                                <div className="card bg-primary w-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-6 border-end border-white">
                                                <h6 className="mb-0 text-center text-white">Total Marks</h6>
                                                <h6 className="mb-0 text-center text-white">{TutorCompletedAssStudentDetailApiData?.student?.total_marks}</h6>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-6">
                                                <h6 className="mb-0 text-center text-white">
                                                    Obtained Marks
                                                </h6>
                                                <h6 className="mb-0 text-center text-white">{TutorCompletedAssStudentDetailApiData?.student?.marks_obtained}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-center">
                                <Link to="/tutor/completed-assessment">
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                        View Other Assessment
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorSubjectiveTest